import { attr, customElement, FASTElement, observable } from '@microsoft/fast-element';
import { AnalyticsSummaryTableColumnTemplate as template } from './summary-table-column.template';
import { AnalyticsSummaryTableColumnStyle as styles } from './summary-table-column.styles';
import { IBuyerAnalyticsService, IVppaService } from '../../../../../services';
import { IEnumService } from '../../../../../services/enum.service';
import { VppaRankings } from '../../../../../types';
import { Button } from '@genesislcap/foundation-zero';
import { starHighlightedIcon, starUnHighlightedIcon } from '../../../../../styles';
import { IMarketDepthService } from '../../../../../services/market-depth.service';
import {
  MarketDepthCriteriaType,
  MarketDepthField,
  MarketDepthOperation,
  MarketDepthTable,
} from '../../../../../routes/market-depth/market-depth';
import { CONTRACT_TYPE, METHOD_EXECUTION, PRODUCT_TYPE } from '../../../../../utils';
import { Route } from '@microsoft/fast-router';

const name = 'summary-table-column';

@customElement({
  name,
  template,
  styles,
})
export class AnalyticsSummaryTableColumn extends FASTElement {
  @IBuyerAnalyticsService buyerAnalyticsService: IBuyerAnalyticsService;
  @IVppaService vppaService: IVppaService;
  @IEnumService enumService: IEnumService;
  @IMarketDepthService marketDepthService: IMarketDepthService;

  favoriteBtn: Button;

  @attr data: VppaRankings;
  @attr isFirst: boolean = false;
  @attr isLast: boolean = false;

  @observable isFavorite: boolean = false;

  constructor() {
    super();
  }

  dataChanged() {
    if (this.data) {
      this.getFavoriteStatus();
    }
  }

  getFavoriteStatus() {
    this.vppaService.getWatchlistVppa(this.data).then((response) => {
      if (response.REPLY.length > 0) {
        this.isFavorite = true;
        this.favoriteBtn.innerHTML = starHighlightedIcon();
        this.favoriteBtn.title = 'Remove from Watchlist';
      } else {
        this.isFavorite = false;
        this.favoriteBtn.innerHTML = starUnHighlightedIcon();
        this.favoriteBtn.title = 'Add to Watchlist';
      }
      this.favoriteBtn.disabled = false;
    });
  }

  public navigateToMarketDepth() {
    this.marketDepthService.criteriaList = [
      {
        FIELD: MarketDepthField.ISO,
        VALUE: this.data.ISO,
        OPERATION: MarketDepthOperation.EQUAL,
        TABLE: MarketDepthTable.BOTH,
        TYPE: MarketDepthCriteriaType.STRING,
      },
      {
        FIELD: MarketDepthField.TECHNOLOGY,
        VALUE: this.data.TECHNOLOGY,
        OPERATION: MarketDepthOperation.EQUAL,
        TABLE: MarketDepthTable.BOTH,
        TYPE: MarketDepthCriteriaType.STRING,
      },
      {
        FIELD: MarketDepthField.PRODUCT_TYPE,
        VALUE: this.buyerAnalyticsService.currentPreferences.PRODUCT_TYPE,
        OPERATION: MarketDepthOperation.EQUAL,
        TABLE: MarketDepthTable.BOTH,
        TYPE: MarketDepthCriteriaType.STRING,
      },
      {
        FIELD: MarketDepthField.METHOD_EXECUTION,
        VALUE:
          this.data.CONTRACT_TYPE === CONTRACT_TYPE.MINI_POST_BUILD_VPPA_AUTO_EXECUTED
            ? METHOD_EXECUTION.MINI_POST_BUILD_VPPA_AUTO_EXECUTED
            : METHOD_EXECUTION.RFQ,
        OPERATION: MarketDepthOperation.EQUAL,
        TABLE: MarketDepthTable.BOTH,
        TYPE: MarketDepthCriteriaType.STRING,
      },
      {
        FIELD: MarketDepthField.CONTRACT_TYPE,
        VALUE: this.data.CONTRACT_TYPE,
        OPERATION: MarketDepthOperation.EQUAL,
        TABLE: MarketDepthTable.BOTH,
        TYPE: MarketDepthCriteriaType.STRING,
      },
    ];
    this.marketDepthService.selectedVppaId = this.data.UNIQUE_ID;
    Route.path.push(`market-depth`);
  }

  public favoriteWatchlistVppa() {
    this.favoriteBtn.disabled = true;
    if (!this.isFavorite) {
      this.vppaService.eventInsertFavoritedVppa(this.data.VPPA_ID).then((response) => {
        this.getFavoriteStatus();
      });
    } else {
      this.vppaService.eventDeleteFavoritedVppa(this.data.VPPA_ID).then((response) => {
        this.getFavoriteStatus();
      });
    }
  }
}
